var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsAnimations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-39ab0bd6": "",
    width: 32,
    height: 110,
    viewBox: "0 0 64 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "animation-arrows_4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.15223 3.82091C0.189842 2.11236 1.42442 0 3.38537 0C4.31079 0 5.16434 0.498861 5.61851 1.30516L61.3054 100.168C64.7373 106.26 64.7378 113.703 61.3068 119.796L5.61829 218.695C5.16426 219.501 4.3108 220 3.38545 220C1.42469 220 0.190404 217.888 1.15304 216.179L55.4429 119.843C58.8772 113.749 58.8779 106.303 55.4449 100.208L1.15223 3.82091Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsAnimations);
export default __webpack_public_path__ + "static/media/arrows_animations.226f756317b8e97bd0b6aecc32cf8720.svg";
export { ForwardRef as ReactComponent };